import { FeasibilityType } from '../model';
import { orderBy } from 'lodash';
import { deflateModelVariables } from '../util';

export function getFeasibleAssignedValue(fieldName, itctFields) {
    if (FeasibilityType[fieldName]?.length === 1) {
        let value = itctFields[FeasibilityType[fieldName][0]];
        if (value && value.defaultValue) {
            let valueString = value.defaultValue;
            if (fieldName.indexOf("Accuracyclass") > -1) {
                if (valueString?.indexOf("/") > -1) {
                    valueString = valueString.replace("/", "(") + ")";
                }
                valueString = valueString.replace(".", ",");
            } else if (fieldName === "Selector.varAltitudem") {
                valueString = valueString?.replace(".0", "") * 1000;
            }
            return {
                name: valueString,
                title: valueString,
                fromITCT: true
            };
        }
    }
    return null;
}

export function getITCTPayload(fieldName, value, itctFields, itctSettings, selectedValues) {
    let payload = [];
    let payloadSorted = [];
    if(fieldName == 'Selector.varCapacitivedDivider' && (value == 'No Capacitive divider (CD)' || value.indexOf('type') > -1 || value?.includes("NONO"))){
        value = undefined;
    }
    if (value && fieldName) {
        let fields = FeasibilityType[fieldName];

        if (fieldName.indexOf("Core") > -1 && fieldName.indexOf("Fs") > -1) {
            payload.push({ ...itctFields["CorePowerFactor"], value: itctFields["CorePowerFactor"]?.defaultValue });
        }
        if (fieldName === "Selector.varType") {
            value = value?.split(" ")?.map(v => v?.replace(" ", "")?.replace(".", ""));
            value = [value[0], value[1][0], value[1][1], value[1][2], value[1][3]];
        } else if (fieldName === "Selector.varCompleteratioA") {
            value = value?.toLowerCase().replace(/\/\//g, "/")?.replace("+cd", "");
            if (value?.indexOf("x") > -1) {
                let lpn = value?.split("/")[0]?.split("x").map(v => v?.replace("x", ""));
                value = lpn[1] + "-" + (lpn[1] * lpn[0]) + value?.substring(value?.indexOf('/'));
            }
            value = [value];
        } else if (fieldName === "Selector.varIthtimeIdynkA") {
            value = [value?.substring(0, value.indexOf("(") + ".0"),
            value?.substring(value.indexOf("(") + 1, value.indexOf("s)")),
            value?.substring(value.indexOf("/") + 1).replace(" ", "")
            ];
        } else if (fieldName === "Selector.varAltitudem") {
            value = [(value / 1000) + ".0"];
        } else if (fieldName === "Selector.varFrequencyHz") {
            //Condition to handle frequency values with "/"
            if (value?.includes("/") && value?.indexOf("/") > -1) {
                value = value.split("/");
                value = [value[0]?.replace("/", "")];
            }
            //Frequency values without "/"
            value = [value];
        } else if (fieldName.indexOf("Accuracyclass") > -1) {
            value = [value.replace(",", ".").replace("(", "/").replace(")", "")];
        // } else if (fieldName === "Selector.varAmbienttemperature"){
        //     //Only 40C as a standard value to be considered. 
        //     //Even if user choose higher value during his selection it must be converted to 40C 
        //     value = '40';
        //     value = [value];
        // }
        } else if(fieldName == 'Selector.varCapacitivedDivider'){
            value = [value.slice(0,6)];
        }
         else {
            value = [value];
        }

        for (let f = 0; f < fields?.length; f++) {
            payload.push({ ...itctFields[fields[f]], value: value[f] });
        }
    }
    
    return payload;
}

function getRatioValues (values, maxValue){
    let finalValues = [];
    let value = '';
    finalValues = values.map(v => {
        if(v.name.indexOf('x') > -1){
            let value1 = v.name.split('x')[0];
            let value2 = v.name.split('x')[1].split('/')[0];
            if(value1 * value2 <= maxValue){
                return v;
            }
        }
        else if(v.name.indexOf('-') > -1){
            let value1 = v.name.split('/')[0].split('-')[0];
            let value2 = v.name.split('/')[0].split('-')[v.name.split('/')[0].split('-').length - 1];
            if(value1 <= maxValue && value2 <= maxValue){
                return v;
            }
        }
        else{
            //case values like 10/1
            value = v.name.split('/')[0];
            if(value <= maxValue){
                return v;
            }
        } 
    });

    finalValues = finalValues.filter(v => v != undefined);
    return finalValues;
}

export function getFeasibleValues(fieldName, regex, isCustom, values, itctData, itctFields, selectedValues, ratioValues, IthtimeIdynkAValues, itctSettings, materialKey) {
    let fields = FeasibilityType[fieldName];

    //Remove model values and consider only values from ITCT engine
    if(!isCustom && fieldName != 'Selector.varType' && fieldName != 'Selector.varPolarity' && fieldName != 'Selector.varAltitudem' && fieldName != 'Selector.varIcthA' && fieldName != 'Selector.varInsulationvoltagekV' && fieldName != 'Selector.varInsulationclass'){
        values = values.filter(v=>v.fromITCT == true);
    }

    //if(fieldName == 'Selector.varType' && regex.toString().indexOf('>') != -1){
        //values = values.filter(v => v.name.replace(/ /g, '').indexOf(regex.toString().replace(/[>,]/g, '')) == 0);
    //}

    if(fieldName == 'Selector.varType' && materialKey == 'EPDS_ITCTTPU40'){
        values = values.filter(v => v.name.indexOf('TPU 40') > -1);
    }
    //Filter Ratio values based on Type
    if(fieldName == 'Selector.varCompleteratioA'){
        values = ratioValues.length > 0 ? ratioValues : values;
        if(selectedValues['Selector.varType'] && (selectedValues['Selector.varType'].slice(-1)=='1' || selectedValues['Selector.varType'].slice(-1)=='3')){
            values = values.filter(v=>v.name.indexOf('x') == -1);
        }
        else if(selectedValues['Selector.varType'] && (selectedValues['Selector.varType'].slice(-1)=='2' || selectedValues['Selector.varType'].slice(-1)=='4')){
            values = values.filter(v=>v.name.indexOf('x') > -1);
        }

        if(selectedValues['Selector.varType']){
            const typeValue = selectedValues['Selector.varType'].split('.')[0].slice(-1);
            if(typeValue =='0'){
                values = getRatioValues(values, 600);
            }
            else if(typeValue == '1' || typeValue == '3'){
                values = getRatioValues(values, 1250);
            }
            else if(typeValue == '4'){
                values = getRatioValues(values, 1500);
            }
            else if(typeValue == '5'){
                values = getRatioValues(values, 2000);
            }
            else if(typeValue == '6'){
                values = getRatioValues(values, 2500);
            }
            else if(typeValue == '7'){
                values = getRatioValues(values, 3000);
            }
            else if(typeValue == '8'){
                values = getRatioValues(values, 3200);
            }
        }
    }

    let valuesString = values.map(v => v.name);
    if (!isCustom) {
        if (fields?.length > 1) {
            let mainField = fields[0];
            let value = itctData[mainField];
            let valueArray = [];
            if (itctFields[mainField]) {
                valueArray = [itctFields[mainField].defaultValue];
            } else if (itctData[mainField]) {
                valueArray = Object.keys(itctData[mainField])?.map(k => k.replace("[", "").replace("]", ""));
            }
            if (regex?.length) {
                valueArray = valueArray.filter(v => regex[0] === v);
            }
            let stringArray = [];
            valueArray.forEach(s => {
                stringArray = stringArray.concat(getNestedValues(fieldName, value["[" + s + "]"], s + " ", 1, regex));
            })
            stringArray.forEach(k => {
                if (valuesString.indexOf(k) === -1) {
                    values = [...values, { name: k, title: k, fromITCT: true, state: 0 }];
                } else {
                    values[valuesString.indexOf(k)].author = 3;
                }
            })
            values = orderBy(values, ['name'], ['asc']);
        } else if (fields?.length === 1 && itctData[fields[0]]) {
            Object.keys(itctData[fields[0]]).forEach(k => {
                k = k.replace(/\[/g, "").replace(/\]/g, "");

                if (fieldName.indexOf("Accuracyclass") > -1) {
                    if (k?.indexOf("/") > -1) {
                        k = k.replace("/", "(") + ")";
                    }
                    k = k.replace(".", ",");
                }
                if (valuesString.indexOf(k) === -1) {
                    values = [...values, { name: k, title: k, fromITCT: true, state: 0 }];
                } else {
                    values[valuesString.indexOf(k)].author = 3;
                }
            })
        }
    } else if (isCustom && fields?.length === 1) {
        let defaultValue = getFeasibleAssignedValue(fieldName, itctFields);
        if (defaultValue && valuesString.indexOf(defaultValue.name) === -1) {
            values = [...values, { ...defaultValue }];
        } else if (defaultValue) {
            values[valuesString.indexOf(defaultValue.name)].author = 3;
        }
    }

    if(fieldName == 'Selector.varCapacitivedDivider'){
        //if CD available in ratio. Remove NONONO and RONONO from Capacitive Devider
        if(selectedValues['Selector.varCompleteratioA'] && selectedValues['Selector.varCompleteratioA'].indexOf('+CD') > -1){
            values = values.filter(v=>v.name.indexOf('N0N0N0') == -1 && v.name.indexOf('R0N0N0') == -1);
        }
        else if (selectedValues['Selector.varCompleteratioA']){
            values = values.filter(v => v.name.indexOf('N0N0N0') > -1 || v.name.indexOf('R0N0N0') > -1);
        }

        if(selectedValues['Selector.varPolarity'] && selectedValues['Selector.varPolarity'] == 'P1-P2'){
            values = values.filter(v=>v.name.length > 2 && v.name.slice(0, 1) == 'N');
        }
        else if(selectedValues['Selector.varPolarity'] && selectedValues['Selector.varPolarity'] == 'P2-P1'){
            values = values.filter(v=>v.name.length > 2 && v.name.slice(0, 1) == 'R');
        }
    }

    //Finalize values by removing unwanted values and by adding required values according to site settings
    //Add required values
    if(itctSettings.itctFixedValues[fieldName] && values.length > 0){
        values = [];
        itctSettings.itctFixedValues[fieldName].forEach(element => {
            if(!values.firstOrDefault(v => v.name == element)){
                values = [...values, { name: element, title: element, fromITCT: true, state: 0 }];
            }
        });

        //Remove items which are not part of itctFixedValues
        values.forEach(value => {
            if(!itctSettings.itctFixedValues[fieldName].firstOrDefault(element => element == value.name )){
                values = values.filter(v => v.name != value.name);
            }
        })
    }

    //Remove values
    if(itctSettings.itctRemoveValues[fieldName]){
        itctSettings.itctRemoveValues[fieldName].forEach(element => {
            values = values.filter(v => v.name != element)
        });
    }

    //Sorting Burder values
    if(fieldName == 'Selector.GrpCore1.varCore1BurdenVA' || fieldName == 'Selector.GrpCore2.varCore2BurdenVA' || fieldName == 'Selector.GrpCore3.varCore3BurdenVA' || fieldName == 'Selector.GrpCore4.varCore4BurdenVA' || fieldName == 'Selector.GrpCore5.varCore5BurdenVA' || fieldName == 'Selector.GrpCore6.varCore6BurdenVA'){
        values = values.sort((a,b) => (parseFloat(a.name) > parseFloat(b.name)) ? 1: -1);
    }

    //Keep only assigned value in Selector.varIcthA
    if(fieldName == 'Selector.varIcthA' && selectedValues['Selector.varIcthA']){
        values = values.filter(v => v.name == selectedValues['Selector.varIcthA']);
    }

    //Value filtering on varIthtimeIdynkA based on value of Type
    if(fieldName == 'Selector.varIthtimeIdynkA'){
        values = IthtimeIdynkAValues.length > 0 ? IthtimeIdynkAValues : values;
        if(selectedValues['Selector.varType'] && (selectedValues['Selector.varType'].slice(-1)=='1' || selectedValues['Selector.varType'].slice(-1)=='3')){
            values = values.filter(v=>v.name.indexOf('-') == -1);
        }
        else if(selectedValues['Selector.varType'] && (selectedValues['Selector.varType'].slice(-1)=='2' || selectedValues['Selector.varType'].slice(-1)=='4')){
            values = values.filter(v=>v.name.indexOf('-') > -1);
        }
    }

    //Value filtering on Selector.varInsulationvoltagekV based on TPU and Standard
    if(materialKey && selectedValues['Selector.varStandard'] && fieldName == 'Selector.varInsulationvoltagekV'){
        if( materialKey == 'EPDS_ITCTTPU4' ||  materialKey == 'EPDS_ITCTTPU40'){
            if(selectedValues['Selector.varStandard'].indexOf('IEC') > -1){
                values = values.filter(v => v.name.indexOf('12/28/75') == 0 || v.name.indexOf('7,2/20/60') == 0 || v.name.indexOf('3,6/10/40') == 0)
                //Add the above values if not available. Change this implementaion to fetch the values from sitesettings
                if(values.filter(v => v.name.indexOf('12/28/75') == 0).length == 0){
                    values = [...values, { name: '12/28/75', title: '12/28/75', fromITCT: true, state: 0 }];
                }

                if(values.filter(v => v.name.indexOf('7,2/20/60') == 0).length == 0){
                    values = [...values, { name: '7,2/20/60', title: '7,2/20/60', fromITCT: true, state: 0 }];
                }

                if(values.filter(v => v.name.indexOf('3,6/10/40') == 0).length == 0){
                    values = [...values, { name: '3,6/10/40', title: '3,6/10/40', fromITCT: true, state: 0 }];
                }
            }
            else if(selectedValues['Selector.varStandard'].indexOf('GOST') > -1){
                values = values.filter(v => v.name.indexOf('12/42/75') == 0 || v.name.indexOf('7,2/32/60') == 0 || v.name.indexOf('3,6/24/40') == 0)
                //Add the above values if not available. Change this implementaion to fetch the values from sitesettings
                if(values.filter(v => v.name.indexOf('12/42/75') == 0).length == 0){
                    values = [...values, { name: '12/42/75', title: '12/42/75', fromITCT: true, state: 0 }];
                }

                if(values.filter(v => v.name.indexOf('7,2/32/60') == 0).length == 0){
                    values = [...values, { name: '7,2/32/60', title: '7,2/32/60', fromITCT: true, state: 0 }];
                }

                if(values.filter(v => v.name.indexOf('3,6/24/40') == 0).length == 0){
                    values = [...values, { name: '3,6/24/40', title: '3,6/24/40', fromITCT: true, state: 0 }];
                }
            }
        }
        else if(materialKey == 'EPDS_ITCTTPU6'){
            //values = values.filter(v => v.name.indexOf('24') == 0 );

            //Insulation voltage values for TPU 6 IEC
            if(selectedValues['Selector.varStandard'].indexOf('IEC') > -1){
                values = values.filter(v => v.name.indexOf('24/50/125') == 0 || v.name.indexOf('17,5/38/95') == 0 || v.name.indexOf('12/28/75') == 0 || v.name.indexOf('7,2/20/60') == 0 || v.name.indexOf('3,6/10/40') == 0)
                
                //Add the above values if not available. Change this implementaion to fetch the values from sitesettings
                if(values.filter(v => v.name.indexOf('24/50/125') == 0).length == 0){
                    values = [...values, { name: '24/50/125', title: '24/50/125', fromITCT: true, state: 0 }];
                }
                if(values.filter(v => v.name.indexOf('17,5/38/95') == 0).length == 0){
                    values = [...values, { name: '17,5/38/95', title: '17,5/38/95', fromITCT: true, state: 0 }];
                }
                if(values.filter(v => v.name.indexOf('12/28/75') == 0).length == 0){
                    values = [...values, { name: '12/28/75', title: '12/28/75', fromITCT: true, state: 0 }];
                }

                if(values.filter(v => v.name.indexOf('7,2/20/60') == 0).length == 0){
                    values = [...values, { name: '7,2/20/60', title: '7,2/20/60', fromITCT: true, state: 0 }];
                }

                if(values.filter(v => v.name.indexOf('3,6/10/40') == 0).length == 0){
                    values = [...values, { name: '3,6/10/40', title: '3,6/10/40', fromITCT: true, state: 0 }];
                }
                values = values.sort((a,b) => (parseFloat(a.name) < parseFloat(b.name)) ? 1: -1);
            }
            //Insulation voltage values for TPU 6 GOST
            else if(selectedValues['Selector.varStandard'].indexOf('GOST') > -1){
                values = values.filter(v => v.name.indexOf('24/50/125') == 0 || v.name.indexOf('17,5/42/95') == 0 || v.name.indexOf('12/42/75') == 0 || v.name.indexOf('7,2/32/60') == 0 || v.name.indexOf('3,6/24/40') == 0)
                //Add the above values if not available. Change this implementaion to fetch the values from sitesettings
                if(values.filter(v => v.name.indexOf('24/50/125') == 0).length == 0){
                    values = [...values, { name: '24/50/125', title: '24/50/125', fromITCT: true, state: 0 }];
                }
                if(values.filter(v => v.name.indexOf('17,5/42/95') == 0).length == 0){
                    values = [...values, { name: '17,5/42/95', title: '17,5/42/95', fromITCT: true, state: 0 }];
                }
                if(values.filter(v => v.name.indexOf('12/42/75') == 0).length == 0){
                    values = [...values, { name: '12/42/75', title: '12/42/75', fromITCT: true, state: 0 }];
                }

                if(values.filter(v => v.name.indexOf('7,2/32/60') == 0).length == 0){
                    values = [...values, { name: '7,2/32/60', title: '7,2/32/60', fromITCT: true, state: 0 }];
                }

                if(values.filter(v => v.name.indexOf('3,6/24/40') == 0).length == 0){
                    values = [...values, { name: '3,6/24/40', title: '3,6/24/40', fromITCT: true, state: 0 }];
                }
                values = values.sort((a,b) => (parseFloat(a.name) < parseFloat(b.name)) ? 1: -1);
            }



        }
        else if(materialKey == 'EPDS_ITCTTPU5'){
            //Insulation voltage values for TPU 5 IEC 

            //values = values.filter(v => v.name.indexOf('17,5') == 0 ||  v.name.indexOf('17.5') == 0);
            if(selectedValues['Selector.varStandard'].indexOf('IEC') > -1){
                values = values.filter(v => v.name.indexOf('17,5/38/95') == 0 || v.name.indexOf('12/28/75') == 0 || v.name.indexOf('7,2/20/60') == 0 || v.name.indexOf('3,6/10/40') == 0)
                //Add the above values if not available. Change this implementaion to fetch the values from sitesettings
                if(values.filter(v => v.name.indexOf('17,5/38/95') == 0).length == 0){
                    values = [...values, { name: '17,5/38/95', title: '17,5/38/95', fromITCT: true, state: 0 }];
                }
                if(values.filter(v => v.name.indexOf('12/28/75') == 0).length == 0){
                    values = [...values, { name: '12/28/75', title: '12/28/75', fromITCT: true, state: 0 }];
                }

                if(values.filter(v => v.name.indexOf('7,2/20/60') == 0).length == 0){
                    values = [...values, { name: '7,2/20/60', title: '7,2/20/60', fromITCT: true, state: 0 }];
                }

                if(values.filter(v => v.name.indexOf('3,6/10/40') == 0).length == 0){
                    values = [...values, { name: '3,6/10/40', title: '3,6/10/40', fromITCT: true, state: 0 }];
                }
                values = values.sort((a,b) => (parseFloat(a.name) < parseFloat(b.name)) ? 1: -1);
            }
            //Insulation voltage values for TPU 5 GOST
            else if(selectedValues['Selector.varStandard'].indexOf('GOST') > -1){
                values = values.filter(v => v.name.indexOf('17,5/42/95') == 0 || v.name.indexOf('12/42/75') == 0 || v.name.indexOf('7,2/32/60') == 0 || v.name.indexOf('3,6/24/40') == 0)
                //Add the above values if not available. Change this implementaion to fetch the values from sitesettings
                if(values.filter(v => v.name.indexOf('17,5/42/95') == 0).length == 0){
                    values = [...values, { name: '17,5/42/95', title: '17,5/42/95', fromITCT: true, state: 0 }];
                }
                if(values.filter(v => v.name.indexOf('12/42/75') == 0).length == 0){
                    values = [...values, { name: '12/42/75', title: '12/42/75', fromITCT: true, state: 0 }];
                }

                if(values.filter(v => v.name.indexOf('7,2/32/60') == 0).length == 0){
                    values = [...values, { name: '7,2/32/60', title: '7,2/32/60', fromITCT: true, state: 0 }];
                }

                if(values.filter(v => v.name.indexOf('3,6/24/40') == 0).length == 0){
                    values = [...values, { name: '3,6/24/40', title: '3,6/24/40', fromITCT: true, state: 0 }];
                }
                values = values.sort((a,b) => (parseFloat(a.name) < parseFloat(b.name)) ? 1: -1);
            }


        }
        else if(materialKey == 'EPDS_ITCTTPU') {
            if(selectedValues['Selector.varStandard'].indexOf('IEC') > -1){
                //values = values.filter(v => v.name.indexOf('40,5') == 0 ||  v.name.indexOf('40.5') == 0);
                values = values.filter(v => v.name.indexOf('36/70/170') == 0 || v.name.indexOf('24/50/125') == 0 || v.name.indexOf('17,5/38/95') == 0 || v.name.indexOf('12/28/75') == 0 || v.name.indexOf('7,2/20/60') == 0 || v.name.indexOf('3,6/10/40') == 0)
                
                //Add the above values if not available. Change this implementaion to fetch the values from sitesettings
                if(values.filter(v => v.name.indexOf('36/70/170') == 0).length == 0){
                    values = [...values, { name: '36/70/170', title: '36/70/170', fromITCT: true, state: 0 }];
                }
                if(values.filter(v => v.name.indexOf('24/50/125') == 0).length == 0){
                    values = [...values, { name: '24/50/125', title: '24/50/125', fromITCT: true, state: 0 }];
                }
                if(values.filter(v => v.name.indexOf('17,5/38/95') == 0).length == 0){
                    values = [...values, { name: '17,5/38/95', title: '17,5/38/95', fromITCT: true, state: 0 }];
                }
                if(values.filter(v => v.name.indexOf('12/28/75') == 0).length == 0){
                    values = [...values, { name: '12/28/75', title: '12/28/75', fromITCT: true, state: 0 }];
                }

                if(values.filter(v => v.name.indexOf('7,2/20/60') == 0).length == 0){
                    values = [...values, { name: '7,2/20/60', title: '7,2/20/60', fromITCT: true, state: 0 }];
                }

                if(values.filter(v => v.name.indexOf('3,6/10/40') == 0).length == 0){
                    values = [...values, { name: '3,6/10/40', title: '3,6/10/40', fromITCT: true, state: 0 }];
                }
                values = values.sort((a,b) => (parseFloat(a.name) < parseFloat(b.name)) ? 1: -1);
            }
            else if(selectedValues['Selector.varStandard'].indexOf('GOST') > -1){
                values = values.filter(v => v.name.indexOf('40.5/95/190') == 0 || v.name.indexOf('24/50/125') == 0 || v.name.indexOf('17,5/42/95') == 0 || v.name.indexOf('12/42/75') == 0 || v.name.indexOf('7,2/32/60') == 0 || v.name.indexOf('3,6/24/40') == 0)
                //Add the above values if not available. Change this implementaion to fetch the values from sitesettings
                if(values.filter(v => v.name.indexOf('40.5/95/190') == 0).length == 0){
                    values = [...values, { name: '40.5/95/190', title: '40.5/95/190', fromITCT: true, state: 0 }];
                }
                if(values.filter(v => v.name.indexOf('24/50/125') == 0).length == 0){
                    values = [...values, { name: '24/50/125', title: '24/50/125', fromITCT: true, state: 0 }];
                }
                if(values.filter(v => v.name.indexOf('17,5/42/95') == 0).length == 0){
                    values = [...values, { name: '17,5/42/95', title: '17,5/42/95', fromITCT: true, state: 0 }];
                }
                if(values.filter(v => v.name.indexOf('12/42/75') == 0).length == 0){
                    values = [...values, { name: '12/42/75', title: '12/42/75', fromITCT: true, state: 0 }];
                }

                if(values.filter(v => v.name.indexOf('7,2/32/60') == 0).length == 0){
                    values = [...values, { name: '7,2/32/60', title: '7,2/32/60', fromITCT: true, state: 0 }];
                }

                if(values.filter(v => v.name.indexOf('3,6/24/40') == 0).length == 0){
                    values = [...values, { name: '3,6/24/40', title: '3,6/24/40', fromITCT: true, state: 0 }];
                }
                values = values.sort((a,b) => (parseFloat(a.name) < parseFloat(b.name)) ? 1: -1);
            }
        }
    }

    return values;
}

function getCoreNumber(fieldName){
    if(fieldName.indexOf('varCore') > -1){
        return fieldName.split('varCore')[1][0] - 1;
    }
    else{
        return 0;
    }
}

function getNestedValues(fieldName, value, string, index, regex) {
    let field = FeasibilityType[fieldName][index];
    value = value[field];
    let stringArray = [];
    if (index < FeasibilityType[fieldName]?.length - 1) {
        Object.keys(value).forEach(v => {
            let currentValue = v.split("]")[0]?.replace("[", "").replace("]", "");
            let isMatch = false;
            if (regex[index]?.indexOf(">") > -1 && currentValue > regex[index].replace(">", "")) {
                isMatch = true;
            } else if (regex[index]?.indexOf("<") > -1 && currentValue < regex[index].replace("<", "")) {
                isMatch = true;
            } else if (regex[index] && currentValue == regex[index]) {
                isMatch = true;
            } else if (!regex[index]) {
                isMatch = true;
            }

            if (isMatch) {
                if (field === "Dimension") {
                    currentValue = "." + currentValue;
                }
                stringArray = stringArray.concat(getNestedValues(fieldName, value[v], string + currentValue, index + 1, regex));
            }
        });
        return stringArray;
    } else if (index === FeasibilityType[fieldName]?.length - 1) {
        Object.keys(value).forEach(v => {
            stringArray.push(string + v.split("]")[0]?.replace("[", "").replace("]", ""));
        });
        return stringArray;
    }
}

export function feasiblyEnabled(enabledFields, configuration) {
    const fields = [...enabledFields] || [];
    if (configuration?.data) {
        Object.keys(configuration.data).forEach(k => {
            FeasibilityType[k]?.forEach(v => {
                if (!fields.includes(v)) {
                    fields.push(v);
                }
            })
        })
    }
    return fields;
}

export function getAllVariables(model){
    const variables = deflateModelVariables(model);
    return variables;
}

export function setBasePageValues(basePageValues, configurations, materialKey, initialLoad){
    const values = [...basePageValues] || [];
    if(configurations && initialLoad){
        const configuration = configurations[materialKey] && configurations[materialKey][0];
        const {model} = configuration;
        const variables = deflateModelVariables(model);
        variables.forEach(v => {
            if(v.assignedValue != null && !values.includes(v.assignedValue)){
                values.push(v.assignedValue);
            }
        })
        /* Object.keys(variables).forEach(v => {
            if(!values.includes(v)){
                values.push(v);
            }
        }) */
        //values.push(variables.filter(v=>v.assignedValue != null));
    }
    return values;
}

export function setValues(variableName, variableValues,materialKey, configurations, initialLoad){
    let values = [...variableValues] || [];
    if(configurations && initialLoad){
        const configuration = configurations[materialKey] && configurations[materialKey][0];
        const {model} = configuration;
        const variables = deflateModelVariables(model);
        variables.forEach(v => {
            if(v.fullyQualifiedName == variableName){
                values = v.values;
            }
        })
    }

    return values;
}